import BathtubOutlinedIcon from '@mui/icons-material/BathtubOutlined'
import BedOutlinedIcon from '@mui/icons-material/BedOutlined'
import { useMediaQuery, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Chip from '@rentspree/component-2023.components.atoms.chip'
import Typography from '@rentspree/component-2023.components.atoms.typography'
import classNames from 'classnames'

import { PropertyDetailLabel } from 'components/common/molecules/property-detail-label'
import { FloorOutlined } from 'constant/icons'

import styles from './index.module.scss'

export interface TitleSectionProps {
  propertyDetails: PublicListingPropertyDetails
  isPreview?: boolean
  address: string
}

const TitleSection: React.FC<TitleSectionProps> = ({ propertyDetails, isPreview, address }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const { price, beds, baths, sqft, propertyType, yearBuilt } = propertyDetails
  const isStudio = !beds || beds <= 0

  return (
    <Box className={styles.container}>
      <Box>
        {isPreview && (
          <Box mb={2}>
            <Chip variant="filled" label="Draft" />
          </Box>
        )}
        {/* This typo suppose to use 'h4' but this variant is currently broken,
      using h3 with override font-size as a workaround */}
        <Box pb={1.5}>
          <Typography variant="h3" fontSize={isMobile ? 28 : 32}>
            ${price.toLocaleString()}/month
          </Typography>
        </Box>

        <Typography className={styles.bold} variant={isMobile ? 'body-medium' : 'title'}>
          <Box
            className={classNames(styles.listingPropertiesContainer, { [styles.mobile]: isMobile })}
          >
            <PropertyDetailLabel
              icon={<BedOutlinedIcon />}
              amount={isStudio ? 'Studio' : beds}
              label={isStudio ? '' : 'bed'}
              hasPluralForm={!isStudio}
            />
            <PropertyDetailLabel icon={<BathtubOutlinedIcon />} amount={baths} label="bath" />
            <PropertyDetailLabel
              icon={<img src={FloorOutlined} alt="Floor" />}
              amount={sqft}
              label="sqft"
              hasPluralForm={false}
            />
          </Box>
        </Typography>
      </Box>
      <Box>
        <Typography
          variant={isMobile ? 'body-medium' : 'body-large'}
          className={styles.propertyInformation}
        >
          <Box className={styles.propertiesItem}>
            <Box>{propertyType}</Box>•<Box>{yearBuilt ? `Built ${yearBuilt}` : ''}</Box>
          </Box>

          <Box className={styles.propertiesItem}>{address}</Box>
        </Typography>
      </Box>
    </Box>
  )
}

export default TitleSection
